(function () {

    function addToCart($subscriptionProduct) {
        var redirectToCheckout = Boolean($subscriptionProduct.data("redirectToCheckout"));

        var variantId = $subscriptionProduct.data("variantId");
        var sellingPlanId = $subscriptionProduct.data("sellingPlanId");
        var choiceVariantId = $(".member-choice.selected", $subscriptionProduct).data("variantId");
        var giftWithPurchaseVariantId = $subscriptionProduct.data("giftWithPurchaseId");

        // A unique timestamp to go along with the cart item, allowing it to be unique in the cart. 
        // Unless someone adds a subscription twice within the same millisecond, this keeps line items for subs separated.
        var uniqueNumber = new Date().getTime();

        var data = {
            items: [
                {
                    "id": variantId,
                    "quantity": 1,
                    "selling_plan": sellingPlanId,
                    "properties": {
                        '_box_num': uniqueNumber
                    }
                }
            ]
        };

        if (choiceVariantId) {
            data.items.push({
                "id": choiceVariantId,
                "quantity": 1,
                "properties": {
                    '_free_prod': "true",
                    '_free_prod_num': uniqueNumber
                }
            });
        }

        if (giftWithPurchaseVariantId) {
            data.items.push({
                "id": giftWithPurchaseVariantId,
                "quantity": 1,
                "properties": {
                    '_free_prod': "true",
                    '_free_prod_num': uniqueNumber
                }
            });
        }

        // Perform a POST to add the selected items to the cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function (data) {
                // Indicate to the theme something was added to the cart
                //
                // No need to call this if we are redirecting to checkout.
                // On Safari, this'll cause an error if we do not prevent this upon redirect.
                // It kicks off ajax requests, and when those ajax requests get cancelled, their error handlers get called.
                if (!redirectToCheckout) {
                    goCart.addItemToCartHandler(data);
                }
                
                // Reset confirm buttons
                $(".subscription-modules .confirm-button").attr("disabled", true);
                // Reset member choice selections
                $(".subscription-modules .member-choice-container .member-choice").removeClass("selected");
                // Reset subscription selections
                $(".subscription-modules .subscription-product").removeClass("selected");
                $(".subscription-modules .subscription-product-container").removeClass("col-lg-4");
                $(".subscription-modules .subscription-product-container").removeClass("col-lg-6");
                $(".subscription-modules .subscription-product-container").addClass("col-lg-4");

                if (redirectToCheckout) {
                    window.location.href = "/checkout";
                }
            },
            error: function (error) {
                goCart.ajaxRequestFail();
            }
        });
    }

    $(document).ready(function () {
        // Wire up select buttons
        $("body").on("click", ".subscription-modules .select-button", function (e) {
            e.preventDefault();

            var $button = $(e.target);
            var $subscriptionProduct = $button.closest(".subscription-product");
            var $subscriptionProducts = $(".subscription-modules .subscription-product");
            var $subscriptionProductContainer = $subscriptionProduct.closest(".subscription-product-container");
            var $subscriptionProductContainers = $(".subscription-modules .subscription-product-container");
            var $memberChoices = $(".member-choice", $subscriptionProduct);
            var $confirmButtons = $(".subscription-modules .confirm-button");

            if ($memberChoices.length <= 0) {
                addToCart($subscriptionProduct);
                return;
            }

            var isAlreadySelected = $subscriptionProduct.hasClass("selected");

            $subscriptionProducts.removeClass("selected");
            $subscriptionProductContainers.removeClass("col-lg-3");
            $subscriptionProductContainers.removeClass("col-lg-4");
            $subscriptionProductContainers.removeClass("col-lg-6");

            if (isAlreadySelected) {
                $subscriptionProduct.removeClass("selected");

                $subscriptionProductContainers.addClass("col-lg-4");
            }
            else {
                $subscriptionProducts.addClass("unselected");
                $subscriptionProduct.removeClass("unselected");
                $subscriptionProduct.addClass("selected");

                $subscriptionProductContainers.addClass("col-lg-3");

                $subscriptionProductContainer.removeClass("col-lg-3");
                $subscriptionProductContainer.addClass("col-lg-6");
            }

            // Ensure all member choices are reset
            $memberChoices.removeClass("selected");
            $confirmButtons.attr("disabled", $memberChoices.length > 0);

            $(".confirm-container span", $subscriptionProduct).removeClass("d-none");
        });

        $("body").on("click", ".subscription-modules .member-choice-container a", function (e) {
            e.preventDefault();

            if ($(e.target).closest("a").attr("disabled")) {
                return;
            }

            $(".subscription-modules .member-choice-container .member-choice").removeClass("selected");
            $(e.target).closest(".member-choice").addClass("selected");
            $(".subscription-modules .confirm-button").attr("disabled", false);
        });

        $("body").on("click", ".subscription-modules .confirm-button", function (e) {
            e.preventDefault();

            var $button = $(e.target);
            var $subscriptionProduct = $button.closest(".subscription-product");

            addToCart($subscriptionProduct);
        });
    });
})();